/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Features_SubtitleInputs */

const en_landing_features_subtitle = /** @type {(inputs: Landing_Features_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Three habits that keep your image yours, from the first pass to the last.`)
};

const zh_landing_features_subtitle = /** @type {(inputs: Landing_Features_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`三个习惯，让你的图从第一轮到最后一轮都还是你的图。`)
};

/**
* | output |
* | --- |
* | "Three habits that keep your image yours, from the first pass to the last." |
*
* @param {Landing_Features_SubtitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const landing_features_subtitle = /** @type {((inputs?: Landing_Features_SubtitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Features_SubtitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_features_subtitle(inputs)
	return zh_landing_features_subtitle(inputs)
});
export { landing_features_subtitle as "landing.features.subtitle" }